// extracted by mini-css-extract-plugin
export default {"container":"J_g","sidebarWrapper":"J_fj","title":"J_cX"};